import moment from 'moment';

export const formatDate = (date, isUTC, formatType) => {
  if (!date) {
    return '';
  }
  const formatStr = formatType || 'MM/DD/YY';
  const momentDate = isUTC ? moment.utc(date) : moment(date);

  return momentDate.format(formatStr);
};

export const isValidDate = date => {
  if (!date) {
    return false;
  }

  return moment(date).isValid();
};
